export const PROGRAM_DASHBOARD_CONFIG = {
  pgi: {
    id: "pgi",
    slug: "pgi-dashboard",
    title: "PGI Dashboard",
    subtitle: "Performance Grading Index",
    eyebrow: "Performance Grading Index · District Review",
    description:
      "Composite district performance score across learning outcomes, infrastructure, access & equity, and identity compliance.",
    dataNotice:
      "Official MoE PGI scores are not imported. Scores are derived from live operational datasets (OSH, infrastructure, data entry, Aadhaar & APAAR).",
    accent: "#2563eb",
    sidebarItems: [
      { id: "executive", label: "Executive Overview" },
      { id: "blocks", label: "Block Performance" },
      { id: "domains", label: "Domain Scores" },
      { id: "insights", label: "Policy Insights" },
    ],
    footerNote: "PGI proxy built from School Health Index, infrastructure, data entry and identity modules.",
  },
  nas: {
    id: "nas",
    slug: "nas-dashboard",
    title: "NAS Dashboard",
    subtitle: "National Achievement Survey",
    eyebrow: "National Achievement Survey · Learning Outcomes",
    description:
      "Monitor learning outcome indicators, subject readiness proxies and block-level achievement spread.",
    dataNotice:
      "Official NAS assessment results are not imported. Learning outcome proxies use School Health Index and primary-stage enrolment signals.",
    accent: "#7c3aed",
    sidebarItems: [
      { id: "executive", label: "Executive Overview" },
      { id: "blocks", label: "Block Performance" },
      { id: "domains", label: "Learning Domains" },
      { id: "insights", label: "Policy Insights" },
    ],
    footerNote: "NAS proxy indicators derived from operational learning and enrolment datasets.",
  },
  nipun: {
    id: "nipun",
    slug: "nipun-dashboard",
    title: "NIPUN Dashboard",
    subtitle: "Foundational Literacy & Numeracy",
    eyebrow: "NIPUN Bharat · FLN Monitoring",
    description:
      "Track foundational literacy and numeracy readiness through early-age enrolment, primary participation and data quality.",
    dataNotice:
      "Official NIPUN FLN assessment data is not imported. Indicators use early-age enrolment, primary participation and data-entry completion.",
    accent: "#14b8a6",
    sidebarItems: [
      { id: "executive", label: "Executive Overview" },
      { id: "blocks", label: "Block Performance" },
      { id: "domains", label: "FLN Indicators" },
      { id: "insights", label: "Policy Insights" },
    ],
    footerNote: "NIPUN proxy built from age-wise enrolment and data-entry operational feeds.",
  },
  ger: {
    id: "ger",
    slug: "ger-dashboard",
    title: "GER Dashboard",
    subtitle: "Gross Enrolment Ratio",
    eyebrow: "Gross Enrolment Ratio · Stage Analysis",
    description:
      "Analyse enrolment distribution across pre-primary, primary, upper-primary, secondary and higher-secondary stages.",
    dataNotice:
      "Population denominators for official GER are not available. Stage enrolment shares and block-wise spread are shown as operational GER proxies.",
    accent: "#ff8a1f",
    sidebarItems: [
      { id: "executive", label: "Executive Overview" },
      { id: "blocks", label: "Block Performance" },
      { id: "domains", label: "Stage Breakdown" },
      { id: "insights", label: "Policy Insights" },
    ],
    footerNote: "GER proxies computed from class-wise and stage-wise enrolment analytics.",
  },
  pat: {
    id: "pat",
    slug: "pat-dashboard",
    title: "PAT Dashboard",
    subtitle: "Periodic Assessment Test",
    eyebrow: "Periodic Assessment Test · Readiness Review",
    description:
      "Monitor assessment readiness through data completion, Aadhaar and APAAR coverage, and teacher qualification signals.",
    dataNotice:
      "Official PAT assessment cycle data is not imported. Readiness score is derived from data entry, identity compliance and teacher CTET indicators.",
    accent: "#ec4899",
    sidebarItems: [
      { id: "executive", label: "Executive Overview" },
      { id: "blocks", label: "Block Performance" },
      { id: "domains", label: "Readiness Domains" },
      { id: "insights", label: "Policy Insights" },
    ],
    footerNote: "PAT readiness built from data entry completion, Aadhaar, APAAR and CTET operational feeds.",
  },
};

export const PROGRAM_PATHS = Object.values(PROGRAM_DASHBOARD_CONFIG).map((c) => `/${c.slug}`);

export const getProgramConfig = (programId) => PROGRAM_DASHBOARD_CONFIG[programId] || null;

export const getProgramFromPath = (pathname = "") => {
  const hit = Object.values(PROGRAM_DASHBOARD_CONFIG).find((c) => pathname.includes(c.slug));
  return hit?.id || null;
};
